import {TempusDominus} from '@eonasdan/tempus-dominus'
import {initTooltips} from "./V3/Services/Tooltip";

import './bootstrap';
import jstz from 'jstimezonedetect';

import './Commisioning/macAddresses';
import customchosen from './components/custom-chosen';
import customfn from "./_functions.js";
import {ModalVueSetup} from "./windowFunction.js";
import clp from './_clp.js'
import datagrid from './_datagrid.js'
import './flows/access-group';
import './flows/create-user';
import './flows/create-inventorygroup';
import './flows/edit-inventory';
import './flows/commissioning';
import './flows/faq';

// Hardware
import './hardware';

// Custoemrs
import './companies';

// Inventory
import './inventory';

// Users
import './users';

// oAuth
import './oauth';

import './windowFunction';

import './utilities';

window.datagrid = datagrid;

var pageIsDirty = window.pageIsDirty = false;

$(function () {

    let datePickers = document.querySelectorAll('.datepicker');
    datePickers.forEach(element => {
        let format = element.getAttribute('data-dateformat');
        let minDate = element.getAttribute('data-min-date');

        const tempusDominus = new TempusDominus(element, {
            display: {
                components: {
                    clock: false
                }
            },
            localization: {
                format: format
            }
        });

        if (minDate) {
            tempusDominus.updateOptions({
                restrictions: {
                    minDate: new Date(minDate)
                }
            });
        }
    });

    // Set the timezone
    if($('.detect_timezone').length) {
        var timezone = jstz.determine().name();
        $.ajax({
            url: '/settimezone',
            data: {user_timezone: timezone}
        });
    }

    if (window.devicePixelRatio > 1) {
        var logo = $('.navbar-brand img.hidden-xs');
        logo.each(function(i) {
            var lowres = $(this).attr('src');
            var highres = lowres.replace(".", "@2x.");
            $(this).attr('src', highres);
        });
    }


    $(document).on('click', '.trigger-logout', function(event) {
        event.preventDefault();

        if($(this).attr('data-openid-logout-url') && $(this).data('openid-logout-url') != "") {
            var logout_window = window.open($(this).data('openid-logout-url'), 'openid-logout', "height=450,width=600,status=yes,toolbar=no,menubar=no,location=no");
            setTimeout(function(){
                logout_window.close();
                document.getElementById('logout-form').submit();
            }, 3000);
        } else {
            document.getElementById('logout-form').submit();
        }
    });

    // Show Search if form is not open // event.preventDefault() is important, this prevents the form from submitting
    $(document).on('click', '.search-form-mask:not(.open) form[role="search"] button[type="submit"]', function(event) {
        event.preventDefault();

        var $form = $(this).closest('form'),
            $input = $form.find('input[type="search"]');
        $form.closest('.search-form-mask').removeClass('closed');
        $form.closest('.search-form-mask').addClass('open');
        $input.focus().click();
    });

    $(document).find('input.sb-search-input').on('keyup', function(){
        // determine the length
        var value = $(this).val();
        // If length is 0 then remove the x
        if(value.length == 0){
            $(this).next().next().find('span.fa-close').addClass('d-none');
        }
        // Else show the x
        else{
            $(this).next().next().find('span.fa-close').removeClass('d-none');
        }
    })

    $(document).on('click', '.open form[role="search"] button[type="submit"], .open form[role="search"] input[type="submit"]', function(event) {
        var $form = $(this).closest('form'),
            $input = $form.find('input');

        if($input.val() == "") {
            customfn.closeSearch($form)
        }
    });

    $(document).on('click', 'form[role="search"] button[type="reset"]', function(event) {
        var $form = $(this).closest('form'),
            $input = $form.find('input');

        $input.val("");
        $form.trigger('submit');
        $(this).find('span.fa-close').addClass('d-none');
        customfn.closeSearch($form)
    });

    $(document).on('hidden.bs.modal', '#modal-wrapper .modal', function (e) {
        $(this).remove();
        var refresh = true;
        if($(this).hasClass('refresh-page')) {
            let button = $(document).find('.btn[data-refreshing-text]');
            customfn.setButtonText(button, 'refreshing');
            button.attr('disabled','disabled').prop('disabled',true);
            location.reload();
        }
        if($(this).hasClass('get_errors_for_release_errors')){
            $('a.release_centre_check.link').show();
        }

        if($(this).hasClass('refresh-user-tags-grid')){
            var $userOverview = $(document).find('#company_team_employees');
            var url = $userOverview.data('refresh-url');
            if (typeof url != 'undefined') {
                $.get(url, function (data) {
                    if (data.html) {
                        $userOverview.html(data.html);
                    }
                })
            }
            var $tagOverview = $(document).find('#company_tags');
            var url = $tagOverview.data('refresh-url');
            if (typeof url != 'undefined') {
                $.get(url, function (data) {
                    if (data.html) {
                        $tagOverview.html(data.html);
                    }
                })
            }
        }
        if($(this).hasClass('centre-assign-tags-to-user')){
            var $usersOverview = $(document).find('#centre-users-overview');
            var url = $usersOverview.data('refresh-url');
            if (typeof url != 'undefined') {
                $.get(url, function (data) {
                    if (data.html) {
                        $usersOverview.html(data.html);
                    }
                })
            }
        }

        if (this.classList.contains('refresh-access-methods')) {
            // wait for DOM to be loaded so invalidValues is populated
            $('document').ready(function(){
                const invalidValues = document.getElementsByClassName('is-invalid');
                if (invalidValues.length === 0) {
                    customfn.refreshAccessMethodsOverview();
                }
            });
        }

        if (this.classList.contains('refresh-centre-users')) {
            if (document.getElementById('users-overview')) {
                location.reload();
            }
        }

        if($(this).hasClass('refresh-visitors-grid')){
            var $visitorsOverview = $(document).find('#centre-visitors-overview');
            var url = $visitorsOverview.data('refresh-url');
            if (typeof url != 'undefined') {
                $.get(url, function (data) {
                    if (data.html) {
                        $visitorsOverview.html(data.html);
                    }
                })
            }
        }
        if($(this).hasClass('no-hardware-refresh')){
            refresh = false;
        }

        if(refresh) {
            setTimeout(function () {
                clp.refreshHardware($(document));
            }, 2000);
        }

    });

    $(document).on('shown.bs.modal', '#modal-wrapper .modal', function (e) {
        ModalVueSetup();

        if($(this).hasClass('send_tree_list')){
            customfn.sendTree();
        }
        if($(this).hasClass('get_errors_for_release')){
            customfn.getReleaseErrors();
        }
        if($(this).hasClass('restore_iq')){
            customfn.restoreIq();
        }
        const timePickers = document.querySelectorAll('.timepicker');
        timePickers.forEach(element => {
            new TempusDominus(element, {
                display: {
                    components: {
                        calendar: false,
                    }
                },
                localization: {
                    format: "HH:mm",
                    locale: 'en-GB', // default is 'en' (en-US) which will add AM/PM button
                },
            });
        });

        const datePickers = document.querySelectorAll('.datepicker');
        datePickers.forEach(element => {
            const format = element.getAttribute('data-dateformat');

            new TempusDominus(element, {
                display: {
                    components: {
                        clock: false
                    }
                },
                localization: {
                    format: format
                }
            });
        });
        if($(this).hasClass('access_rule_basic_data')){
            var type = $(this).find('select#timeframes').val();
            customfn.setTimeFrameOverview(type);
        }
        if($(this).hasClass('create-user-flow') &&
            $(this).find('#email').length){
            customfn.validateEmail();
        }


    });

    let tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    initTooltips(tooltipTriggerList);

    $(document).on('keyup', '.checkbox-filter form[role="search"] input.sb-search-input', function(event) {
        $(this).closest('form[role="search"]').submit();
    });

    $(document).on('mouseover', '.navbar-main li.dropdown', function(){
        var index = $(this).index();
        if($('.navbar-main > li:not(:eq('+index+')).dropdown.active').length > 0) {
            $('.navbar-main > li:not(:eq('+index+')).dropdown.active .dropdown-menu').hide();
        }
    })
    .on('mouseleave', '.navbar-main li.dropdown', function(){
        $('.navbar-main li.active .dropdown-menu:hidden').show();
    });

    $(document).on('submit', '.checkbox-filter form[role="search"]', function(event) {
        event.preventDefault();
        var $checkboxes = $(this).closest('.checkbox-filter').find('.checkbox:not(.always), .form-check:not(.always)');
        var $input = $(this).find('input.sb-search-input');
        var search = $input.val();
        search = search.toLowerCase();

        if(search == "") {
            $(this).closest('.checkbox-filter').find('.checkbox, .form-check').show().removeClass('closed').addClass('open');
        } else {
            $checkboxes.each(function (index, el) {
                var label = $(el).find('label');
                if (label.text().toLowerCase().indexOf(search) < 0) {
                    $(el).hide().addClass('closed').removeClass('open');
                } else {
                    $(el).show().addClass('open').removeClass('closed');
                }
            });
        }
    });

    $(document).on('change', '#offlineAccessModal .checkboxes .checkbox input[type="checkbox"]', function (event) {
        var selected = $('#offlineAccessModal .checkboxes .checkbox input[type="checkbox"]:checked').length;
        if(selected > 39) {
            event.preventDefault();
            $(this).prop("checked", false).attr('checked', false).removeAttr('checked');
            $('#offlineAccessModal .offline-selected').closest('div').addClass('text-danger');
            $('#offlineAccessModal .offline-selected').closest('div').shake(3, 7, 400);
        } else {
            $('#offlineAccessModal .offline-selected').text(selected);
            if(selected == 39) {
                $('#offlineAccessModal .offline-selected').closest('div').addClass('text-danger');
            } else {
                $('#offlineAccessModal .offline-selected').closest('div').removeClass('text-danger');
            }
        }
    });

    $(document).on('change', '#centreSpacesModal .checkboxes .checkbox input[type="checkbox"]', function (event) {
        var selected = $('#centreSpacesModal .checkboxes .checkbox input[type="checkbox"]:checked').length;
        if(selected < 2) {
            event.preventDefault();
            $(this).prop("checked", true).attr('checked', true);
            $('#centreSpacesModal .spaces-selected').closest('div').addClass('text-danger');
            $('#centreSpacesModal .spaces-selected').closest('div').shake(3, 7, 400);
        } else {
            $('#centreSpacesModal .spaces-selected').text(selected);
            if(selected == 2) {
                $('#centreSpacesModal .spaces-selected').closest('div').addClass('text-danger');
            } else {
                $('#centreSpacesModal .spaces-selected').closest('div').removeClass('text-danger');
            }
        }
    });

    $(document).on('click', '.row-clickable tbody tr', function(){
        var href = $(this).find('a:first').attr('href');
        if(typeof href !== "undefined" && href !== "") {
            window.location.href = href;
        }
    });
    $(document).on('click', '.row-clickable tbody tr td', function(){
        var href = $(this).closest('tr').find('a:first').attr('href');
        if(typeof href !== "undefined" && href !== "") {
            window.location.href = href;
        }
    });

    const timePickers = document.querySelectorAll('.timepicker');
    timePickers.forEach(element => {
        new TempusDominus(element, {
            display: {
                components: {
                    calendar: false,
                }
            },
            localization: {
                format: "HH:mm",
                locale: 'en-GB', // default is 'en' (en-US) which will add AM/PM button
            }
        });
    });

    customchosen.chosen($("select.chosen-select"));

    $(document).on('click', 'button[data-loading-text], a[data-loading-text]', function(ev){
        customfn.setButtonLoadingState($(this));
    });

    $(document).on('click', '.button-dropdown .dropdown-menu a', function(ev){
        if($(this).closest('.button-dropdown').find('.dropdown-toggle').attr('data-dropdownloading-text')) {
            var d = "disabled";
            let button = $(this).closest('.button-dropdown').find('.dropdown-toggle');
            customfn.setButtonText(button, 'dropdownloading');
            button.addClass(d).attr(d, d).prop(d, true);
        }
    });

    if($('input.typeahead').length > 0){
        $('input.typeahead').each(function(){
            customfn.typeAhead($(this))
            $(this).parent('div').addClass('form-group--typeahead');
        });
    }

    if($('span[data-clp="status"]').length > 0) {
        var iqs = [],
            repeaters = [],
            locks = [],
            tags = [],
            devices = [];

        // Get list of IQS to fetch data from all at once
        $('span[data-clp="status"][data-type="iq"]').each(function(index, el){
            iqs.push($(el).data('value'));
            $(el).parent().find('.spinner').show();
            $(el).parent().find('.status-button').each(function() {
                customfn.setButtonLoadingState(this);
            });
        });

        // Get list of Repeaters to fetch data from all at once
        $('span[data-clp="status"][data-type="repeater"]').each(function(index, el){
            repeaters.push($(el).data('value'));
            $(el).parent().find('.spinner').show();
            $(el).parent().find('.status-button').each(function() {
                customfn.setButtonLoadingState(this);
            });
        });

        // Get list of Locks to fetch data from all at once
        $('span[data-clp="status"][data-type="lock"]').each(function(index, el){
            if(locks.indexOf($(el).data('value')) === -1) {
                locks.push($(el).data('value'));
            }
            $(el).parent().find('.spinner').show();
            $(el).parent().find('.status-button').each(function() {
                customfn.setButtonLoadingState(this);
            });
        });

        // Get list of Locks to fetch data from all at once
        $('span[data-clp="status"][data-type="tag"]').each(function(index, el){
            if(tags.indexOf($(el).data('value')) === -1) {
                tags.push($(el).data('value'));
            }
            $(el).parent().find('.spinner').show();
            $(el).parent().find('.status-button').each(function() {
                customfn.setButtonLoadingState(this);
            });
        });

        // Get list of devices to fetch data from all at once
        $('span[data-clp="status"][data-type="device"]').each(function(index, el){
            if(devices.indexOf($(el).data('value')) === -1) {
                devices.push($(el).data('value'));
            }
            $(el).parent().find('.spinner').show();
            $(el).parent().find('.status-button').each(function() {
                customfn.setButtonLoadingState(this);
            });
        });

        clp.getStatusFromClp(iqs, repeaters, locks, tags, devices);
    }

    $(document).on('click', '.refresh_hardware_detail', function(ev){
        customfn.doInitialStatusCheck();
    })

    $(document).on('click', '.status-button', function(ev){

        ev.preventDefault();

        var iqs = [],
            repeaters = [],
            locks = [],
            tags = [],
            devices = [],
            parent = $(this).closest('.status');

        // Get list of IQS to fetch data from all at once
        parent.find('span[data-clp="status"][data-type="iq"]').each(function(index, el){
            iqs.push($(el).data('value'));
            $(el).parent().find('.spinner').show();
            $(el).parent().find('.fa').remove();
            $(el).parent().find('.status-button').each(function(){
                customfn.setButtonLoadingState(this);
            });
        });

        // Get list of Repeaters to fetch data from all at once
        parent.find('span[data-clp="status"][data-type="repeater"]').each(function(index, el){
            repeaters.push($(el).data('value'));
            $(el).parent().find('.spinner').show();
            $(el).parent().find('.fa').remove();
            $(el).parent().find('.status-button').each(function(){
                customfn.setButtonLoadingState(this);
            });
        });

        // Get list of Locks to fetch data from all at once
        parent.find('span[data-clp="status"][data-type="lock"]').each(function(index, el){
            if(locks.indexOf($(el).data('value')) === -1) {
                locks.push($(el).data('value'));
            }
            $(el).parent().find('.spinner').show();
            $(el).parent().find('.fa').remove();
            $(el).parent().find('.status-button').each(function(){
                customfn.setButtonLoadingState(this);
            });
        });

        // Get list of Locks to fetch data from all at once
        parent.find('span[data-clp="status"][data-type="tag"]').each(function(index, el){
            if(tags.indexOf($(el).data('value')) === -1) {
                tags.push($(el).data('value'));
            }
            $(el).parent().find('.spinner').show();
            $(el).parent().find('.fa').remove();
            $(el).parent().find('.status-button').each(function(){
                customfn.setButtonLoadingState(this);
            });
        });

        // Get list of devices to fetch data from all at once
        parent.find('span[data-clp="status"][data-type="device"]').each(function(index, el){
            if(devices.indexOf($(el).data('value')) === -1) {
                devices.push($(el).data('value'));
            }
            $(el).parent().find('.spinner').show();
            $(el).parent().find('.fa').remove();
            $(el).parent().find('.status-button').each(function(){
                customfn.setButtonLoadingState(this);
            });
        });

        clp.getStatusFromClp(iqs, repeaters, locks, tags, devices);
    });

    if($('.space-status span[data-clp="locked"]').length > 0) {
        clp.getLocksStatuses();
        clp.getInventoryStatuses();
    }

    $(document).on('click', '.refresh-systree', function(e){
        e.preventDefault();

        var iqs = [],
            repeaters = [],
            locks = [],
            tags = [];

        var parent = $(this).closest('table');

        // Get list of IQS to fetch data from all at once
        parent.find('span[data-clp="status"][data-type="iq"]').each(function(index, el){
            iqs.push($(el).data('value'));

            $(el).closest('tr').next().find('td.error-row').parent().remove();
            $(el).parent().find('.fa, .wifi-symbol').remove();
            $(el).parent().find('.fa, .low-battery').remove();
            $(el).parent().find('.text-danger').remove();
            $(el).parent().find('.spinner').show();
        });

        // Get list of Repeaters to fetch data from all at once
        parent.find('span[data-clp="status"][data-type="repeater"]').each(function(index, el){
            repeaters.push($(el).data('value'));

            $(el).closest('tr').next().find('td.error-row').parent().remove();
            $(el).parent().find('.fa, .wifi-symbol').remove();
            $(el).parent().find('.fa, .low-battery').remove();
            $(el).parent().find('.spinner').show();
        });

        // Get list of Locks to fetch data from all at once
        parent.find('span[data-clp="status"][data-type="lock"]').each(function(index, el){
            locks.push($(el).data('value'));

            $(el).closest('tr').next().find('td.error-row').parent().remove();
            $(el).parent().find('.fa, .wifi-symbol').remove();
            $(el).parent().find('.fa, .low-battery').remove();
            $(el).parent().find('.spinner').show();
        });

        // Get list of Locks to fetch data from all at once
        parent.find('span[data-clp="status"][data-type="tag"]').each(function(index, el){
            tags.push($(el).data('value'));

            $(el).closest('tr').next().find('td.error-row').parent().remove();
            $(el).parent().find('.tag-status').remove();
            $(el).parent().find('.spinner').show();
        });

        clp.getStatusFromClp(iqs, repeaters, locks, tags);

    });


    if($('#centre_employees').length > 0) {
        customfn.checkForFilledTags();
    }

    $(document).on('keyup', '#centre_employees input[name="tag_number"]', function(){
        customfn.checkForFilledTags();
    });

    if($('a[data-autoclick*="true"]').length > 0) {
        $('a[data-autoclick*="true"]').trigger('click');
    }


    // Edit inline forms
    $(document).on('click', '.edit-form', function(ev){
        ev.preventDefault();

        var form = $('form#' + $(this).data('form')),
            fields = $(this).data('fields');

        // Change the text
        $(this).text($(this).data('text-save'));
        // Set another class
        $(this).removeClass($(this).data('edit-class'));
        $(this).addClass($(this).data('save-class'));

        form.addClass('editing');
        // Show the form
        form.find('.' +fields + '-text').addClass('d-none');
        form.find('.' +fields + '-input').removeClass('d-none');

        // Focus on the first input
        form.find('.' +fields + '-input:first input').focus().click();

        // Show the cancel button
        $(this).closest('.sub-grid-buttons').find('button.cancel-edit').show();
        // Show the delete button
        $(this).closest('.sub-grid-buttons').find('button.delete-item').show();

        // Check if there is a action column
        form.find('.actions-column').show();
        form.find('.status-column').hide();
    })

    var submitAjaxForm = function (ev) {
        ev.preventDefault();
        // Unlock the spinner
        $(this).parent().find('.spinner').show();

        // Remove the cancel button
        $(this).closest('.sub-grid-buttons').find('button.cancel-edit').hide();
        // Remove the delete button
        $(this).closest('.sub-grid-buttons').find('button.delete-item').hide();

        var form = $('form#' + $(this).data('form'));
        var save = $(this);
        if (!form.length) {
            form = $(this);
            save = $(this).find('a.save-form')
        }

        var fields = $(this).data('fields');

        form.removeClass('editing');

        // remove all error output
        form.find('.form-group').find('input, select, textarea').removeClass('is-invalid');
        form.find('.form-group p.invalid-feedback').html('').hide();

        $.ajax(form.attr('action'), {
            method: "POST",
            cache: false,
            data: form.serialize(),
            success: function (data) {
                if (data.status && data.status == 1) {
                    // Change the buttons text
                    save.text(save.data('text-edit'));

                    // Set another class
                    save.removeClass(save.data('save-class'));
                    save.addClass(save.data('edit-class'));

                    // If html is set
                    if (data.html) {
                        form.find('.datagrid-wrapper').html(data.html);
                    }
                    else {
                        // hide the form fields
                        form.find('.' + fields + '-text').removeClass('d-none');
                        form.find('.' + fields + '-input').addClass('d-none');
                    }

                    // And set the title of the screen
                    if (data.title) {
                        $(document).find('h1.title').text(data.title);
                    }

                    // Reset typeahead
                    if ($('input.typeahead').length > 0) {
                        $('input.typeahead').each(function () {
                            customfn.typeAhead($(this));
                        });
                    }
                    form.find('.actions-column').hide();
                    form.find('.status-column').show();
                    // Reset chosen
                    customchosen.chosen($("select.chosen-select"));;

                    setTimeout(function () {
                        form.find('.text-success').removeClass('text-success');
                    }, 1000);
                }

                setTimeout(function () {
                    clp.refreshHardware($(document));
                }, 500);

                save.parent().find('.spinner').hide();
            },
            error: function (jqXHR) {
                var data = jqXHR.responseJSON;
                // add the errors
                if (typeof data != "undefined" && data.errors) {
                    $.each(data.errors, function (key) {
                        const input = form.find('input[name="' + key + '"], textarea[name="' + key + '"]');
                        input.addClass('is-invalid');
                        input.closest('div.form-group').find('p.invalid-feedback').html(data.errors[key]).show();
                    });
                }

                save.parent().find('.spinner').hide();

                // Show the cancel button
                save.closest('.sub-grid-buttons').find('button.cancel-edit').show();
                // Show the delete button
                save.closest('.sub-grid-buttons').find('button.delete-item').show();
            }
        });


    };
    // Save the inventory group
    $(document).on('click', 'a.save-form', submitAjaxForm);
    $(document).on('submit', 'form.save-form', submitAjaxForm);

    // Undo editing
    $(document).on('click', '.cancel-edit', function(ev){
        ev.preventDefault();
        $(this).hide();

        // Save button
        var save = $(this).closest('.sub-grid-buttons').find('a.btn');
        save.text(save.data('text-edit'));
        save.removeClass(save.data('save-class'));
        save.addClass(save.data('edit-class'));

        // Remove the delete button
        save.closest('.sub-grid-buttons').find('button.delete-item').hide();

        var form = $('form#' + save.data('form')),
            fields = save.data('fields');

        form.removeClass('editing');

        // Return to standard state
        form.find('.' +fields + '-text').removeClass('d-none');
        form.find('.' +fields + '-input').addClass('d-none');

        form.find('.actions-column').hide();
        form.find('.status-column').show();
    });

    $(document).on('click', '.close-confirm', function(ev){
        var container = $(this).closest('.modal').parent().parent(),
            id = container.attr("id");
        $('a.close_commission[data-bs-target="#'+id+' .modal"], button.close_commission[data-bs-target="#'+id+' .modal"]').each(function() {
            customfn.resetButtonLoadingState(this);
        });
    });

    $(document).on('keyup', '.autosubmit', function(ev){
        var form = $(this).closest('form'),
            val = $(this).val(),
            submit = false;

        if ($(this).attr('data-min')) {
            if (val.length >= parseInt($(this).data('min'))) {
                submit = true;
            }
        } else {
            submit = true;
        }

        if (submit) {
            form.find('.spinner').removeClass('d-none');
            form.find('.autosubmitter').trigger('click');
        }

    });

    $(document).on('click', '.get-modal', function(ev){
        ev.preventDefault();
        var btn = $(this);
        var spin = false;
        if(btn.hasClass('fa')) {
            var oldClass = btn.attr('class');
            var matches = oldClass.match(/(^|\s)fa-\S+/g);
            if(matches) {
                $.each(matches, function(index, el) {
                    btn.removeClass(el.trim());
                });
            }
            btn.addClass('spinner').addClass('anim-spin');
            spin = true;
        }
        if(btn.hasClass('to-spinner')) {
            if(btn.hasClass('btn')) {
                var isbtn = true;
            }
            btn.addClass('spinner').addClass('anim-spin').removeClass('btn');
            spin = true;
        }

        var options = {};
        $.each($(this).data(), function(index, el){
            if(index.match(/(^|\s)modalOption\S+/g)){
                if(el == 'false'){
                    el = false;
                }
                if(el == 'true'){
                    el = true;
                }
                options[index.replace('modalOption','').trim().toLowerCase()] = el;
            }
        });

        customfn.getModal($(this).attr('href'), $(this), options, function(){
            if(spin) {
                btn.removeClass('spinner').removeClass('anim-spin');
                if(btn.hasClass('fa')) {
                    if (typeof matches != "undefined" && matches) {
                        $.each(matches, function (index, el) {
                            btn.addClass(el.trim());
                        });
                    }
                }
                if (typeof isbtn != "undefined" && isbtn) {
                    btn.addClass('btn');
                }
            }
        });
    });

    $(document).on('click', '.remove-queues, .edit-job', function(ev){
        ev.preventDefault();
        var url = $(this).attr('href');
        customfn.getModal(url, $(this));
    })

    //Realy delete the access group
    $(document).on('click', 'button.delete-job-queue', function(ev){
        ev.preventDefault();
        var url = $(this).attr('href');
        var formFields = $(this).closest('form').serialize();

        // Remove the cancel button
        $(document).find('button.cancel-button').hide();

        // Show the spinner
        $(document).find('.delete-div').removeClass('d-none');
        // Hide the message
        $(document).find('.show-message').addClass('d-none');

        customfn.postModal(url, formFields);
    });

    $(document).on('click', 'button.update-job-btn', function(ev){
        ev.preventDefault();
        var url = $(this).attr('href');
        var formFields = $($(this).data('target')).serialize();

        customfn.postModal(url, formFields);
    });

    $(document).on('click', 'button.reload-jobs', function(ev){
        ev.preventDefault();
        customfn.hideModals();
        window.location.reload();
    });

    /**
     * Start centre employees selection
     */

    $(document).on('click', 'button.refresh-the-page', function(ev){
        customfn.setButtonLoadingState($(this));
        window.location.reload(true);
    });

    $(document).on('click', '#select-employees-for-centre', function(ev){
       ev.preventDefault();

       var url = $(this).attr('href');

       customfn.getModal(url, $(this), {keyboard: false, backdrop: 'static'}, function(){
           customfn.searchEmployeetypeAhead($(document).find('#search_employee_text'));
       });
    });

    $(document).on('click', '.delete_select_employee', function(ev){
        var message = $(this).data('remove-text');
        if(confirm(message)) {
            $(this).parent().remove();

            if ($(document).find('#already_selected .hidden_employee_id').length == 0) {
                // show the message
                $(document).find('.no_employees_selected').show();
                //Hide the already selected
                $(document).find('#already_selected').hide();
            }
        }
    });

    $(document).on('click', '#centre_employees_select', function(ev){
        ev.preventDefault();
       // Let's send the employees to the server
        var url = $(this).attr('href');
        var formFields = $(document).find('form#employees_select_form').serialize();

        // Hide the cancel button
        $(document).find('.cancel-button').hide();

        customfn.postModal(url, formFields, {}, function(data){
            if (data.html && data.autoreload) {
                customfn.hideModals();

                $('.' + data.autoreload).find('.datagrid').parent().html('<span class="fa fa-cog fa-spin"></span>');
                setTimeout(function(){ $('.' + data.autoreload).html(data.html); }, 2000)
            }

        });
    });
    /**
     * End centre employees selection
     */

    /**
     * Start set date format of a user
     */
    // Get the modal to select
    $(document).on('click', '.set_date_format', function(ev){
        ev.preventDefault();

        var url = $(this).attr('href');

        customfn.getModal(url, $(this), {keyboard: false, backdrop: 'static'});
    });

    // Save the modal
    $(document).on('click', '.update_date_format', function(ev){
        ev.preventDefault();

        // Get the changeButton
        var changeButton = $(this);
        //get the cancel button
        var cancelButton = changeButton.next();

        let divContainingInput = $(document).find('.set_date_format_radios');
        divContainingInput.find('.invalid-feedback').hide();

        // Get the url
        var url = changeButton.attr('href');

        // Hide the cancel button and set the changebutton to loading
        customfn.setButtonLoadingState(changeButton);
        cancelButton.hide();

        var form = $(document).find('#set_date_format');

        $.ajax(url, {
            method: "POST",
            data: form.serialize(),
            cache: false,
            success : function(data){
               if(data.html){
                    customfn.showModal(data);
               }
            },
            error : function(jqXHR){
                if (jqXHR.responseJSON) {
                    var data = jqXHR.responseJSON;
                    if (data.errors.main_error) {
                        divContainingInput.find('.invalid-feedback').show().find('strong').text(data.errors.main_error);
                    }
                }
            },
        }).always(function() {
            customfn.resetButtonLoadingState(changeButton);
            cancelButton.show();
        });
    });
    /**
     * Start set date format of a user
     */

    /**
     * Start - Remove titanId
     */
    $(document).on('click', '.remove-titanid', function(ev){
        ev.preventDefault();

        var url = $(this).attr('href');

        customfn.getModal(url, $(this), {keyboard: false, backdrop: 'static'});
    });

    $(document).on('click', '.remove-titanid-remove', function(ev){
        ev.preventDefault();

        var url = $(this).attr('href');
        var formFields = $(this).closest('form').serialize();

        // Remove the cancel button
        $(document).find('button.cancel-button').hide();

        customfn.postModal(url, formFields);
    })
    /**
     * End - Remove titanId
     */


    /**
     * start - copy/paste tag number
     */

    $(document).on('paste' , 'input.tag-input', function (e) {
        e.preventDefault();
        var pasteData = '';

        if (window.clipboardData && window.clipboardData.getData) { // IE
            pasteData = window.clipboardData.getData('Text');
        } else if (e.originalEvent.clipboardData && e.originalEvent.clipboardData.getData) {
            pasteData = e.originalEvent.clipboardData.getData('text');
        }
        // Add it to the input field.
        $(this).val('');
        $(this).val(pasteData);

        $(this).focus().trigger(jQuery.Event('keyup', { keycode: 13, which: 13 }));
    });
});

window.resetAccessForm = function (){
    customfn.resetToInitial();
}

jQuery.fn.shake = function(intShakes, intDistance, intDuration) {
    this.each(function() {
        $(this).css("position","relative");
        for (var x=1; x<=intShakes; x++) {
            $(this).animate({left:(intDistance*-1)}, (((intDuration/intShakes)/4)))
                .animate({left:intDistance}, ((intDuration/intShakes)/2))
                .animate({left:0}, (((intDuration/intShakes)/4)));
        }
    });
    return this;
};
